import React, { useState, useEffect } from 'react';
import { Button, Textarea } from "@heroui/react";

interface EditParticipantModalProps {
    editingParticipant: {
        attributes: string;
    };
    onClose: () => void;
    onUpdate: () => void;
    setNewParticipantMetadata: (metadata: string) => void;
}

const EditParticipantModal: React.FC<EditParticipantModalProps> = ({ 
    editingParticipant, 
    onClose, 
    onUpdate,
    setNewParticipantMetadata
}) => {
    const [localMetadata, setLocalMetadata] = useState('');
    const [jsonError, setJsonError] = useState('');

    useEffect(() => {
        if (editingParticipant) {
            setLocalMetadata(prettifyJson(editingParticipant.attributes));
        }
    }, [editingParticipant]);

    const prettifyJson = (json: string) => {
        try {
            const parsed = JSON.parse(json);
            return JSON.stringify(parsed, null, 2);
        } catch (error) {
            return json; // Return original string if it's not valid JSON
        }
    };

    const validateAndSetJson = (value: string) => {
        try {
            JSON.parse(value);
            setLocalMetadata(prettifyJson(value));
            setNewParticipantMetadata(value);
            setJsonError('');
        } catch (error) {
            setLocalMetadata(value);
            setJsonError('Invalid JSON format');
        }
    };

    const handleUpdate = () => {
        try {
            JSON.parse(localMetadata);
            setNewParticipantMetadata(localMetadata);
            onUpdate();
        } catch (error) {
            setJsonError('Cannot update: Invalid JSON format');
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-md">
                <h2 className="text-xl font-bold mb-4 text-neutral-primary">Deelnemers gegevens bewerken</h2>
                <Textarea
                    value={localMetadata}
                    onChange={(e) => validateAndSetJson(e.target.value)}
                    placeholder="Participant Metadata (JSON)"
                    className={`mb-2 font-mono ${jsonError ? 'border-red-500' : ''}`}
                    rows={10}
                />
                {jsonError && <p className="text-red-500 text-sm mb-4">{jsonError}</p>}
                <div className="flex justify-end gap-2">
                    <Button onClick={onClose}>Cancel</Button>
                    <Button onClick={handleUpdate} disabled={!!jsonError}>Update Participant</Button>
                </div>
            </div>
        </div>
    );
};

export default EditParticipantModal;